import { Platform } from '@angular/cdk/platform';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subject, takeUntil } from 'rxjs';

import * as GlobalVariables from '../../global';
import { NewsCO, SchoolCO } from 'src/app/shared/models/ApiModels';
import { ApiService } from 'src/app/shared/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiUrls } from 'src/app/shared/const/Api-urls';

interface NewsRange {
  key: number;
  value: string;
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  newsrange: NewsRange[] = [
    { key: 5, value: 'Latest' },
    { key: 15, value: '15 Days ago' },
    { key: 30, value: '30 Days ago' }
  ];

  selNewsRange!: NewsRange;
  school: SchoolCO | null = null;
  newsList: NewsCO[] = [];
  latestNews?: NewsCO;
  newsList2D: NewsCO[][] = [];

  defaultImg = 'assets/our aim.png';
  imageBaseUrl = ApiUrls.downloadFileUrl1;

  isLoading = false;
  hasError = false;

  constructor(
    private router: Router,
    private platform: Platform,
    private apiService: ApiService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadSchoolFromSession();
    this.selNewsRange = this.newsrange[2];
    this.getNewsList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getNewsList(): void {
    this.isLoading = true;
    this.hasError = false;

    this.apiService
      .getWebNewsList(this.school?.id, this.selNewsRange.key)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const data: NewsCO[] = res?.data ?? [];

          if (!data.length) {
            this.resetLists();
            return;
          }

          this.latestNews = data[0];
          this.newsList = data.slice(1);
          this.newsList2D = this.chunkArray(this.newsList, 2);
        },
        error: (err) => {
          console.error('Error fetching news', err);
          this.hasError = true;
          this.resetLists();
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  private resetLists(): void {
    this.latestNews = undefined;
    this.newsList = [];
    this.newsList2D = [];
    this.isLoading = false;
  }

  private chunkArray<T>(array: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  transformDate(date?: string): string {
    if (!date) return '';
    return moment(date).isValid()
      ? moment(date).format('DD MMM YYYY')
      : '';
  }

  goToFullNews(news: NewsCO): void {
    if (!news?.id) return;

    sessionStorage.setItem('selectedNews', JSON.stringify(news));
    this.router.navigate(['newspage1'], {
      queryParams: { newsId: news.id }
    });
  }

  share(): void {
    if (!this.platform.isBrowser || !navigator.share) return;

    navigator
      .share({
        title: document.title,
        text: 'Check out this news!',
        url: window.location.href
      })
      .catch(err => console.warn('Share failed', err));
  }


  private loadSchoolFromSession(): void {
    const storedSchool = sessionStorage.getItem('school');
    if (!storedSchool) {
      this.showError('No school found in session');
      this.router.navigate(['home']);
      return;
    }
    try {
      this.school = JSON.parse(storedSchool);
    } catch {
      this.showError('Invalid school data in session');
    }
  }

    // -------------------- UI Feedback --------------------

  private showSuccess(message: string): void {
    this.snackBar.open(message, 'X', {
      duration: 3000,
      panelClass: ['snackbar-success']
    });
  }

  private showError(message: string): void {
    this.snackBar.open(message, 'X', {
      duration: 3000,
      panelClass: ['snackbar-error']
    });
  }
}
